import { render, staticRenderFns } from "./InfoBalanceMyAcuvue.vue?vue&type=template&id=e4671384&scoped=true&"
import script from "./InfoBalanceMyAcuvue.vue?vue&type=script&lang=js&"
export * from "./InfoBalanceMyAcuvue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4671384",
  null
  
)

export default component.exports